import React, { useContext } from "react";
import * as API from "../../api";

const SendCprNotificationButton = ({task, patientNotified, setPatientNotified}) => {

  return(
    <>
      <button
        onClick={async () => {
          let res = await API.notifyPatientOfDocument({
            notification: {
              task_id: task.id
            }
          });

          if(res) {
            setPatientNotified(true);
          }
        }}
        className='m-t-lg btn btn-default'
        disabled={patientNotified}
      >
        { !patientNotified && "Send CPR Notification" }
        { patientNotified && "Sent!" }

      </button>
    </>
  )
}
export default SendCprNotificationButton;
